import { useMemo } from "react";
import * as THREE from "three";
import { getToonGradientMap } from "./toonGradient";

/**
 * Builds a MeshToonMaterial bound to the shared gradient map. Use this
 * instead of constructing MeshToonMaterial directly anywhere in the scene.
 */
export function useToonMaterial(color: string, opts?: { emissive?: string; emissiveIntensity?: number }) {
  return useMemo(() => {
    const material = new THREE.MeshToonMaterial({
      color,
      gradientMap: getToonGradientMap(),
    });
    if (opts?.emissive) {
      material.emissive = new THREE.Color(opts.emissive);
      material.emissiveIntensity = opts.emissiveIntensity ?? 1;
    }
    return material;
  }, [color, opts?.emissive, opts?.emissiveIntensity]);
}
